import { Form } from "react-bootstrap";
import ReCAPTCHA from "react-google-recaptcha";
import { recovery, sendCode } from "../../services/serviceVivetuseguro";
import { useState } from "react";
import VerificationInput from "react-verification-input";
import Timer from "../../modules/helpers/Timer";

const SidebarPasswordCodigo = ({
  errorData,
  mensaje,
  formCode,
  recaptchaRef,
  setMensaje,
  setSpinner,
  form,
  setErrorData,
  setCount,
  setFormCode,
  urlApi,
  codRecaptcha,
}) => {
  const [codigo, setCodigo] = useState([]);
  const [endTimerStatus, setEndTimerStatus] = useState(false);
  const [timeCode, setTimeCode] = useState(60000);

  const handleChangeInputs = (element, index) => {
    setMensaje("");
    if (isNaN(element.value)) return false;
    let camposCodigo = document.querySelectorAll(".codigo-field");
    camposCodigo?.forEach((campo) => {
      campo.style.borderColor = "#666666";
      campo.style.color = "var(--bs-offcanvas-color)";
    });
    setCodigo([...codigo.map((d, idx) => (idx === index ? element.value : d))]);
    if (element.nextSibling) {
      element.nextSibling.focus();
    }
  };

  const endTimer = () => {
    setEndTimerStatus(true);
  };

  const handleSetTimer = (t) => {
    setTimeCode(t);
  };

  const handleComplete = (value) => {
    setCodigo(value);
  };

  const handleSubmitCodigo = async (e) => {
    e.preventDefault();

    let camposCodigo = document.querySelectorAll(".codigo-field");
    let codeOtp = parseInt(
      codigo[0] + codigo[1] + codigo[2] + codigo[3] + codigo[4] + codigo[5]
    );
    formCode.code = codeOtp;
    setFormCode(formCode);

    if (isNaN(formCode.code)) {
      camposCodigo?.forEach((campo) => {
        campo.style.borderColor = "var(--rojo)";
      });
      setMensaje("Debes proporcionar un código.");
      setErrorData(true);
      return;
    }

    const token = await recaptchaRef.current.executeAsync();
    recaptchaRef.current.reset();
    if (!token) {
      setMensaje("Captcha inválido, actualizar web");
      return;
    }

    setSpinner(true);

    let objUsuario = {
      id: formCode.id,
      code: formCode.code,
      tokenCaptcha: token,
    };

    try {
      const res = await sendCode(objUsuario, urlApi);

      setSpinner(false);
      if (res.codigo === 0) {
        setMensaje("");
        setErrorData(false);
        setCount(3);
      } else {
        camposCodigo?.forEach((campo) => {
          campo.style.borderColor = "var(--rojo)";
          campo.style.color = "var(--rojo)";
        });
        setMensaje(
          "El código es incorrecto. Por favor, revisa e intenta de nuevo"
        );
        setErrorData(true);
      }
    } catch (err) {
      camposCodigo?.forEach((campo) => {
        campo.style.borderColor = "var(--rojo)";
        campo.style.color = "var(--rojo)";
      });
      setMensaje(err);
      setErrorData(true);
      setSpinner(false);
    }
  };

  const reenviarCodigo = async () => {
    const token = await recaptchaRef.current.executeAsync();
    recaptchaRef.current.reset();
    if (!token) {
      setMensaje("Captcha inválido, actualizar web");
      return;
    }

    setEndTimerStatus(false);
    setTimeCode(60000);

    let objUsuario = {
      identificacion: form.identificacion,
      tokenCaptcha: token,
    };

    try {
      const res = await recovery(objUsuario, urlApi);
      // console.log({ res })
      setSpinner(false);
      if (res.codigo === 0) {
        setMensaje("");
        setErrorData(false);
        setFormCode({ ...formCode, id: res.data, tokenCaptcha: token });

        return;
      } else if (res.codigo === 1) {
        if (res.mensaje === "No se validó el captcha") {
          setMensaje(res.mensaje);
        } else {
          setMensaje("Usuario no encontrado.");
        }
      } else {
        setMensaje(res.mensaje);
      }
      setErrorData(true);
    } catch (err) {
      setMensaje(err);
      setErrorData(true);
    }
  };

  return (
    <>
      <div className="body__login">
        <h2>Código de verificación</h2>
        <p>
          Ingresa tu código de verificación que se ha enviado a tu teléfono
          celular o correo electrónico para recuperar la contraseña.
        </p>
        <Form
          autoComplete="off"
          onSubmit={(e) => {
            e.preventDefault();
          }}
          className="form__modal"
        >
          <div className="row justify-content-center">
          <div className="campos__codigo">
            <VerificationInput
              name="code"
              length={6}
              classNames={{
                character: "codigo-field",
              }}
              validChars="0-9"
              passwordMode={true}
              onComplete={(value) => handleComplete(value)}
              onChange={(value, index) => handleChangeInputs(value, index)}
              placeholder=""
            />
            {errorData && (
              <div
                className="texto__error__campo"
                style={{ textAlign: "center", paddingTop: "1rem", top: "0px" }}
              >
                <p>{mensaje}</p>
              </div>
            )}
          </div>

          <div className="body__login">
            {endTimerStatus ? (
              <p className="auth__subtitle">
                El código expiró{" "}
                <span className="reenviar__codigo" onClick={reenviarCodigo}>
                  Solicitar de nuevo
                </span>
              </p>
            ) : (
              <p className="auth__subtitle">
                Tu código expira en{" "}
                <span style={{ color: "var(--rojo)", display: "inline-block" }}>
                  <Timer
                    mill={timeCode}
                    end={endTimer}
                    status={endTimerStatus}
                    handleSetTimer={handleSetTimer}
                  />
                </span>
              </p>
            )}
          </div>
            <div
              style={{ textAlign: "center" }}
              className="col-12 mt-3 pt-5 mb-4"
            >
              <ReCAPTCHA
                ref={recaptchaRef}
                size="invisible"
                sitekey={codRecaptcha}
              />
              <button className="btn__azul" onClick={handleSubmitCodigo} disabled={endTimerStatus}>
                VALIDAR
              </button>
            </div>
          </div>
        </Form>
      </div>
    </>
  );
};

export default SidebarPasswordCodigo;
